import { FETCH_INCIDENT_DATA, FETCHED_INCIDENT_DATA } from "@@/constants/IncidentConstants";
import { UPDATE_UI_STORE } from "@@/constants/UIConstants";
import { CreateStore, setTrue, withPayload } from "@selkirk-systems/state-management";

/**
 * All Store data must be Immutable.
 * Use StateManagement/StoreUpdater helper functions or
 * import {update} from "@mbernal/simple-immutable"
 * and always return new state in response to dispatches.
 *
 */

const UIStore = CreateStore({
    name: "UIStore",

    events: {
        [FETCH_INCIDENT_DATA]:setTrue("fetchingData"),
        [FETCHED_INCIDENT_DATA]:withPayload("lastEntityUpdate").setValues("lastEntityUpdate").setFalse("fetchingData"),
        /**
         * UPDATE_UI_STORE is a general purpose updater.
         * don't rely on this pattern for all store updates.
         * It promotes bad habits and makes it hard for other stores to determine what
         * is occuring.
         *
         * Any store can listen to all dispatches and update themselves if nessesary.
         * With general UPDATE_STORE disaptches other stores would need to investigate
         * the payload itself to determine if the update was something they cared about.
         *
         * Use specific dispatches and only rely on general dispatches in rare cases.
         *
         * @example [SAVED_TODO_ITEM]
         *
         * In many cases we have a store for lists and single entities, if a TodoListStore
         * wanted to stay up to date after a user saved a change to a todo item that store
         * could listen for the SAVED_TODO_ITEM dispatch and update its own copy of said todo
         * item with the payload.
         */
        [UPDATE_UI_STORE]: withPayload().mergeStore(),
        /**
         * This is what the above is doing behind the scenes. The StoreUpdater is good
         * for simple dispatch responses. If you need something more complex write your own
         * response. For more StoreUpdater helper functions see StateManagement/src/StoreUpdater.js
         * 
         * @example
         * 
         * [UPDATE_UI_STORE]:(action,state)=>{
            return update(state,{
                'merge':action.payload
            })
            }
         */
    },

    state: {
        fetchingData:true,
        lastEntityUpdate:null
    },
});

export default UIStore;
